<template>
  <v-dialog v-model="opened" max-width="1000" persistent>
    <v-form
      ref="formbulky"
      v-model="valid"
      :readonly="!canEdit"
      @submit.prevent="save()"
    >
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="headline">
          {{ !id ? " Tambah" : "Ubah" }} Jadwal Kelas Bulky
          <v-btn icon @click="close()" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-autocomplete
                  label="Jenis Kelas"
                  dense
                  outlined
                  v-model="data.class_type_id"
                  :items="listClassType"
                  item-text="name"
                  item-value="id"
                  clearable
                ></v-autocomplete>
                <v-autocomplete
                  label="Instruktur Kelas"
                  dense
                  outlined
                  v-model="data.class_instructor_id"
                  :items="listClassInstructor"
                  item-text="name"
                  item-value="id"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <date-picker
                  class="mb-6"
                  placeholder="Tanggal Mulai Generate"
                  valueType="format"
                  :format="'YYYY-MM-DD'"
                  v-model="data.start_date"
                  :rules="rules.start_date"
                ></date-picker>
                <date-picker
                  class="mb-6"
                  placeholder="Tanggal Selesai Generate"
                  valueType="format"
                  :format="'YYYY-MM-DD'"
                  v-model="data.end_date"
                  :rules="rules.end_date"
                ></date-picker>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="12">
                <v-select
                  v-model="data.days"
                  :items="dayOptions"
                  item-text="label"
                  item-value="value"
                  label="Pilih Hari"
                  dense
                  outlined
                  multiple
                  chips
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="data.start_time"
                  label="Jam Mulai"
                  type="time"
                  dense
                  outlined
                  :rules="rules.start_time"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="data.end_time"
                  label="Jam Selesai"
                  type="time"
                  dense
                  outlined
                  :rules="rules.end_time"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Kuota"
                  dense
                  outlined
                  v-model="data.quota"
                  type="number"
                  :rules="quota"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12">
                <v-textarea
                  label="Deskripsi"
                  dense
                  outlined
                  v-model="data.description"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" align="end">
              <v-btn
                depressed
                class="ma-1"
                :disabled="loading"
                @click="close()"
              >
                <v-icon small left>mdi-close</v-icon>
                Tutup
              </v-btn>
              <v-btn
                v-if="canEdit"
                type="submit"
                color="success"
                depressed
                class="ma-1"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save()"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { slugify } from "@/core/utils";

export default {
  async mounted() {
    const classType = await ApiService.get("class-type/list");
    this.listClassType = classType.data;

    const classInstructor = await ApiService.get("class-instructor/list");
    this.listClassInstructor = classInstructor.data;
  },
  data() {
    return {
      action: "create",
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      data: {
        class_type_id: null,
        slug: null,
        class_instructor_id: null,
        start_date: null,
        end_date: null,
        days: [],
        start_time: null,
        end_time: null,
        quota: null,
        price: null,
        description: null,
      },
      rules: {
        name: [(v) => !!v || "Nama Instruktur harus diisi"],
        date: [(v) => !!v || "Tanggal Kelas harus diisi"],
        start_time: [(v) => !!v || "Jam Mulai harus diisi"],
        end_time: [(v) => !!v || "Jam Selesai harus diisi"],
        quota: [(v) => !!v || "Kuota harus diisi"],
        price: [(v) => !!v || "Harga harus diisi"],
        days: [(v) => !!v || "Hari harus diisi"],
      },
      dayOptions: [
        { label: "Minggu", value: 0 },
        { label: "Senin", value: 1 },
        { label: "Selasa", value: 2 },
        { label: "Rabu", value: 3 },
        { label: "Kamis", value: 4 },
        { label: "Jumat", value: 5 },
        { label: "Sabtu", value: 6 },
      ],
    };
  },
  props: {
    module: {
      type: String,
    },
    success: {
      type: Function,
      default: function () {},
    },
  },
  methods: {
    open(id) {
      this.opened = true;
      setTimeout(() => {
        this.$refs.formbulky.reset();
        if (id) {
          this.getData(id);
        }
      }, 1);
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      ApiService.get("class-schedule?id=" + id)
        .then(({ data }) => {
          this.data = {
            class_type_id: data.class_type_id,
            slug: data.slug,
            class_instructor_id: data.class_instructor_id,
            start_date: data.start_date,
            end_date: data.end_date,
            start_time: data.start_time,
            end_time: data.end_time,
            quota: data.quota,
            days: data.days,
            price: data.price,
            description: data.description,
          };
          this.loadingData = false;
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleError(response.data);
          }
          this.loadingData = false;
        });
    },
    async save() {
      this.$refs.formbulky.validate();
      if (this.valid) {
        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "class-schedule/bulky";
        if (this.id) {
          url = url + "?id=" + this.id;
        }
        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000,
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    },
    close() {
      this.opened = false;
      this.id = null;
      this.$refs.form.reset();
    },
  },
  watch: {
    ["data.name"](value) {
      this.data.slug = value ? slugify(value) : null;
    },
  },
  computed: {
    canEdit() {
      if (
        this.id &&
        !this.$store.getters.hasPermission(this.module, "update")
      ) {
        return false;
      }

      return true;
    },
  },
};
</script>
